/** High Technology starter personalities were issued only as foils. */
export function isStarterFoil(cardId:string):boolean { return /^ss(179|18[0-5])$/.test(cardId); }
export function hasFoilFinish(cardId:string,foil=false):boolean { return isStarterFoil(cardId)||foil; }
